







































































import {Component, Vue} from 'vue-property-decorator';
import UserService from '../services/UserService';
import {User} from '../types';
import moment from 'moment';

@Component
export default class Users extends Vue {
  private showDeleted: boolean = false;
  private items: User[] = [];

  get filteredItems() {
    if (this.showDeleted) {
      // @ts-ignore
      return this.items.filter(user => user.role === 0);
    } else {
      // @ts-ignore
      return this.items.filter(user => user.role !== 0);
    }
  };

  private loading: boolean = false;
  private role: string = '';
  private roles: { [key: string]: { id: string, name: string } } = {};
  private rolesArray: Array<{ id: string, name: string }> = [];
  private headers: object[] = [
    {
      text: 'id',
      align: 'left',
      value: 'id',
    },
    {text: 'First Name', value: 'first_name'},
    {text: 'Last Name', value: 'last_name'},
    {text: 'Email', value: 'email'},
    {text: 'Created at', value: 'inserted_at'},
    {text: 'Updated at', value: 'updated_at'},
    {text: 'Role', value: 'role'},
    {text: '', value: 'actions'}
  ];
  private snackbar: boolean = false;
  private snackbarText: string = '';
  private snackbarColor: string = '';


  private async mounted() {
    this.loading = true;
    try {
      await this.loadItems();
      await this.getRoles();
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private async loadItems() {
    const {data} = await UserService.getUsers();
    this.items = data;
  }

  private async getRoles() {
    const {data} = await UserService.getRoles();
    this.rolesArray = data;
    for (const role of data) {
      this.roles[role.id] = role;
    }
  }

  private async confirmDelete(item: User) {
    const id = item.id;
    if (confirm('Are you sure you want to delete the user ' + item.email + '?')) {
      const response = await UserService.deleteUser(id);
      if (response.status >= 200 && response.status < 400) {
        this.$store.dispatch('deleteUser', id);
        return this.loadItems();
      }
    }
  }

  private async changePassword(item: User) {
    const newPassword = prompt('Enter a new password for ' + item.email + '?');
    if (newPassword) {
      if (newPassword.length >= 8) {
        try {
          const response = await UserService.updatePassword(item.id, newPassword);
          if (response.status >= 200 && response.status < 400) {
            alert('password has been changed');
            return;
          }
        } catch (e) {
          console.warn('failed', e);
        }
        alert('there was a problem changing the password');
      } else {
        alert('Password must be at least 8 characters long');
      }
    }

  }

  private async updateRole(user: User) {
    try {
      this.loading = true;
      await UserService.updateRole(user.id, this.role);
      const index = this.items.findIndex((item) => item.id === user.id);
      this.items[index].role = this.role;
      this.displaySnackbar('User role updated!', 'blue-grey');
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private displaySnackbar(msg: string, color: string) {
    this.snackbarText = msg;
    this.snackbarColor = color;
    this.snackbar = true;
  }

  private getFormattedDate(date: string) {
    let formatted = '';
    if (date) {
      formatted = moment(date).format('MMM Do YYYY, hh:mm');
    }
    return formatted;
  }
}
